import { SalaryRetention } from '@api'
import { z } from 'zod'

export const MemberSalarySchema = z
  .object({
    fixedSalary: z.object({
      amount: z.number(),
      retention: z.enum([SalaryRetention.MONTHLY, SalaryRetention.YEARLY]),
    }),
    cutOfRevenuePercentage: z.number(),
  })
  .superRefine((data, ctx) => {
    if (!data.fixedSalary?.amount && !data.cutOfRevenuePercentage) {
      ctx.addIssue({
        path: ['cutOfRevenuePercentage'],
        message: 'At least one value must be defined.',
        code: 'custom',
      })
      ctx.addIssue({
        path: ['fixedSalary', 'amount'],
        message: 'At least one value must be defined.',
        code: 'custom',
      })

      return
    }

    if (data.fixedSalary?.amount < 0) {
      ctx.addIssue({
        path: ['fixedSalary', 'amount'],
        message: 'Number must be greater than or equal to 1',
        code: 'custom',
      })
    }

    if (data.cutOfRevenuePercentage < 0) {
      ctx.addIssue({
        path: ['cutOfRevenuePercentage'],
        message: 'Number must be greater than or equal to 1',
        code: 'custom',
      })
    } else if (data.cutOfRevenuePercentage > 100) {
      ctx.addIssue({
        path: ['cutOfRevenuePercentage'],
        message: 'Number must be less than or equal to 100',
        code: 'custom',
      })
    }
  })

export type MemberSalaryType = z.infer<typeof MemberSalarySchema>
